// extracted by mini-css-extract-plugin
export default {"advantageBlock":"advantageBlock-QHJiu","iconAdvantage":"iconAdvantage-T5Fu0","textAdvantage":"textAdvantage-g3546"};